export enum Controls {
  Name = 'name',
  Country = 'country',
  Building = 'building',
  Floors = 'floors',
  FindASpaceTab = 'findASpaceTab',
  MeetingsTab = 'meetingsTab',
  BookingsTab = 'bookingsTab',
  ServiceOrdersTab = 'serviceOrdersTab',
  CalendarTab = 'calendarTab',
  IsActive = 'isActive',
  IsFavourite = 'isFavourite',
}
export enum FindASpaceTabControls {
  SpaceFeatures = 'spaceFeatures',
  Category = 'category',
  Type = 'type',
  Capacity = 'capacity',
}
export enum MeetingsTabControls {
  DashboardRequestType = 'dashboardRequestType',
  DashboardStatus = 'dashboardStatus',
  DashboardMeetingType = 'dashboardMeetingType',
  MeetingRequestType = 'meetingRequestType',
  MeetingStatus = 'meetingStatus',
  VirtualMeetingStatus = 'virtualMeetingStatus',
  UnfulfilledSpaceType = 'unfulfilledSpaceType',
}
export enum BookingsTabControls {
  ServiceOrders = 'serviceOrders',
  SpaceType = 'spaceType',
  MeetingType = 'meetingType',
  DashboardStatus = 'dashboardStatus',
  WaitListStatus = 'waitListStatus',
}
export enum ServiceOrdersTabControls {
  Type = 'type',
  ServiceOrder = 'serviceOrder',
  Status = 'status',
  VirtualServiceOrders = 'virtualServiceOrders',
  VirtualStatus = 'virtualStatus',
  InOfficeIncludeDelete = 'inOfficeIncludeDelete',
  VirtualIncludeDelete = 'virtualIncludeDelete',
}
export enum CalendarTabControls {
  RoomType = 'roomType',
  Capacity = 'capacity',
  SpaceFeatures = 'spaceFeatures',
}

export enum ServiceOrderStatus {
  None = 'None',
  Requested = 'Requested',
  Ordered = 'Ordered',
  Received = 'Received',
  Delivered = 'Delivered',
  Completed = 'Completed',
  Pending = 'Pending',
  Review = 'Review',
}

export enum ServiceOrderCategory {
  Catering = 'catering',
  TaskType = 'TaskType',
}

export interface ReservationStatus {
  DisplayOrder: number;
  EMSStatusID: number;
  Value: string;
  IsActiveStatus: boolean;
}

export interface PreferencesControlsConfig {
  findASpaceTab?: Partial<{ [key in FindASpaceTabControls] }>;
  calendarTab?: Partial<{ [key in CalendarTabControls] }>;
  meetingsTab?: Partial<{ [key in MeetingsTabControls] }>;
  bookingsTab?: Partial<{ [key in BookingsTabControls] }>;
  serviceOrdersTab?: Partial<{ [key in ServiceOrdersTabControls] }>;
}

export interface PreferenceBody {
  id?: string;
  isFavourite: boolean;
  isActive: boolean;
  name: string;
  // countries: string;
  buildings: string;
  floors: string;
  recordsPerPage: string;
  assignedToMe: boolean;
  revision?: number;
  tabFields: { tabFieldId: number; value: string }[];
}

export interface PreferenceDetails {
  id: string;
  isFavourite: boolean;
  isActive: boolean;
  name: string;
  // countries: string;
  buildings: string;
  floors: string;
  recordsPerPage: number;
  assignedToMe: boolean;
  viewDetails: ViewDetail[];
  revision: number;
  allViews: AllViewItem[];
}

export interface ViewDetail {
  tabFieldId: number;
  value: string;
}

export interface AllViewItem {
  id: string;
  name: string;
  isActive: boolean;
  isFavourite: boolean;
  isNew?: boolean;
}

export enum MeetingDashboardStatus {
  Tentative = 'Tentative',
  Pipeline = 'Pipeline',
  Definite = 'Definite',
  Cancelled = 'Cancelled',
  DidNotMaterialize = 'Did Not Materialize',
  NewRequest = 'New Request',
}

export class PreferencesViewData {
  constructor(
    public viewId: string = '',
    public viewName: string = '',
    public isFavourite: boolean = false,
    public isActive: boolean = true,
    // public country: SelectOption[] = [],
    public building: SelectOption[] = [],
    public floors: SelectOption[] = [],
    public assignedToMe: boolean = true,
    public recordsPerPage: number = RECORDS_PER_PAGE,
    public revision: number = 0,
    public findASpaceTab: PreferencesFindASpaceData = new PreferencesFindASpaceData(),
    public calendarTab: PreferencesCalendarData = new PreferencesCalendarData(),
    public meetingsTab: PreferencesMeetingsData = new PreferencesMeetingsData(),
    public bookingsTab: PreferencesBookingsData = new PreferencesBookingsData(),
    public serviceOrdersTab: PreferencesServiceOrdersData = new PreferencesServiceOrdersData(),
    public allViews: AllViewItem[] = []
  ) {}
}

export class PreferencesFindASpaceData {
  constructor(public spaceFeatures: SelectOption[] = [], public capacity: number = CAPACITY_VALUE, public type = '') {}
}

export class PreferencesCalendarData {
  constructor(public roomType: SelectOption[] = ALL_SELECTED,public spaceFeatures: SelectOption[] = [], public capacity: number = CAPACITY_VALUE) {}
}

export class PreferencesMeetingsData {
  constructor(
    public dashboardRequestType: SelectOption[] = ALL_SELECTED,
    public dashboardMeetingType: SelectOption[] = ALL_SELECTED,
    public dashboardStatus: SelectOption[] = MEETING_DASHBOARD_STATUS,
    public inOfficeRequestType: SelectOption[] = ALL_SELECTED,
    public inOfficeStatus: SelectOption[] = MEETING_REQUESTED_TYPE,
    public virtualMeetingRequestStatus: SelectOption[] = MEETING_REQUESTED_TYPE,
    // public waitlistStatus: SelectOption[] = ALL_SELECTED,
    public unfulfilledTeamRequestsSpaceType: SelectOption[] = ALL_SELECTED
  ) {}
}
export class PreferencesBookingsData {
  constructor(
    public serviceOrders: SelectOption[] = ALL_SELECTED,
    public spaceType: SelectOption[] = ALL_SELECTED,
    public meetingType: SelectOption[] = ALL_SELECTED,
    public status: SelectOption[] = BOOKING_RESERVATION_STATUS,
    public waitListStatus: SelectOption[] = WAITLIST_STATUS
  ) {}
}

export class PreferencesServiceOrdersData {
  constructor(
    public inOfficeType: SelectOption[] = ALL_SELECTED,
    public inOfficeServiceOrders: SelectOption[] = ALL_SELECTED,
    public inOfficeStatus: SelectOption[] = SERVICE_ORDER_STATUS,
    public virtualServiceOrders: SelectOption[] = ALL_SELECTED,
    public virtualStatus: SelectOption[] = SERVICE_ORDER_VIRTUAL_STATUS,
    public inOfficeIncludeDelete: boolean = false,
    public virtualIncludeDelete: boolean = false
  ) {}
}

export interface PreferencesViews {
  viewId: string;
  viewName: string;
  isActive: boolean;
  isFavourite: boolean;
  buildingDetails: PreferencesViewBuilding;
}

export interface PreferencesViewBuilding {
  buildingId: number;
  buildingName: string;
}

export interface PreferencesFindASpaceTab {
  spaceFeatures: number[];
  capacity: number;
  category: number;
  type: number;
  amenities: number[];
  otherSpaces: number[];
}

export interface PreferencesCalendarTab {
  roomType: number;
  capacity: number;
}

export interface PreferencesRequestsTab {
  inOfficeRequestType: number;
  inOfficeStatus: number[];
  virtualMeetingRequestStatus: number[];
  waitlistStatus: number[];
  unfulfilledTeamRequestsSpaceType: number;
}

export interface PreferencesAllBookingsTab {
  team: number;
  serviceOrders: number[];
  type: number[];
  meetingType: number[];
  status: number[];
}

export interface PreferencesServiceOrderTab {
  inOfficeType: number[];
  inOfficeServiceOrders: number[];
  inOfficeStatus: number[];
  virtualTypeOfTechnology: number[];
  virtualServiceOrders: number[];
  virtualStatus: number[];
}

export interface SelectOption {
  name: string;
  value: any;
  all?: boolean;
  disabled?: boolean;
  groupText?: string;
  items?: Omit<SelectOption, 'items'>[];
  icon?: string;
}

export interface Country {
  id: number;
  name: string;
  code: number;
}

export const MASTER_VIEW_ID = '1';
export const ALL_SELECTED = [{ value: 'All', name: 'All', all: true }];
export const MEETING_DASHBOARD_STATUS = [

  { value: MeetingDashboardStatus.NewRequest, name: '' },
  { value: MeetingDashboardStatus.Definite, name: '' },
];
export const BOOKING_RESERVATION_STATUS = [
  {
    value: 'AwaitingCheckIn',
    name: '',
  },
  {
    value: 'CheckedIn',
    name: '',
  },
  {
    value: 'Reserved',
    name: '',
  },
  {
    value: 'PendingApproval',
    name: '',
  },
];
export const WAITLIST_STATUS = [{ value: 'Active', name: '' }];
export const CAPACITY_VALUE = 1;
export const FIND_A_SPACE_CATEGORY = 'Individual';

export const SERVICE_ORDER_STATUS = [{ value: ServiceOrderStatus.Requested, name: '' }];
export const SERVICE_ORDER_VIRTUAL_STATUS = [{ value: ServiceOrderStatus.Requested, name: '' }];
export const RECORDS_PER_PAGE = 40;
export const MEETING_REQUESTED_TYPE = [{ name: '', value: ServiceOrderStatus.Requested }];
